// ─────────────────────────────────────────────
// Date Utility — DD/MM/YYYY format throughout
// ─────────────────────────────────────────────

/**
 * Format any date to DD/MM/YYYY display format
 * @param {string|Date} date
 * @returns {string} DD/MM/YYYY or '—'
 */
export const formatDate = (date) => {
  if (!date) return '—';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '—';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Convert DD/MM/YYYY string to YYYY-MM-DD for HTML date input value
 * @param {string} ddmmyyyy
 * @returns {string} YYYY-MM-DD
 */
export const toInputDate = (ddmmyyyy) => {
  if (!ddmmyyyy) return '';
  const parts = ddmmyyyy.split('/');
  if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
  return ddmmyyyy;
};

/**
 * Get today's date in YYYY-MM-DD for max attribute on date inputs
 * @returns {string}
 */
export const todayInputDate = () => {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `${d.getFullYear()}-${month}-${day}`;
};

/**
 * Get today's date in DD/MM/YYYY
 * @returns {string}
 */
export const todayFormatted = () => {
  return formatDate(new Date());
};
